import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'
import InlineIcon from 'components/utils/InlineIcon'
import FormatLoyaltyPoints from 'loyalty/components/Formatters/FormatLoyaltyPoints'
import FormatLoyaltyStatusCredits from 'loyalty/components/Formatters/FormatLoyaltyStatusCredits'
import React, { MouseEventHandler, useCallback } from 'react'
import styled from 'styled-components'

const ClickableIcon = styled(Clickable)`
  // Vertically align the icon with text
  display: flex;
`

interface Props {
  calculationType: 'estimate' | 'exact' | 'additional'
  earnablePoints: number
  statusCredits?: number
  trailingCaption?: string
  /** does not propagate and is default-prevented */
  onInfoIconClick?: MouseEventHandler<HTMLButtonElement>
}

function _PriceRowLoyaltyPointsContent({
  calculationType,
  earnablePoints,
  statusCredits,
  trailingCaption,
  onInfoIconClick,
}: Props) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()

    onInfoIconClick?.(event)
  }, [onInfoIconClick])

  return <Group direction="horizontal" wrap="wrap" gap={4}>
    {calculationType === 'estimate' && <>Earn from <FormatLoyaltyPoints abbreviated points={earnablePoints} /></>}
    {calculationType === 'exact' && <>Earn <FormatLoyaltyPoints abbreviated points={earnablePoints} /></>}
    {calculationType === 'additional' && <>Earn an additional <FormatLoyaltyPoints abbreviated points={earnablePoints} /></>}
    <Group direction="horizontal" verticalAlign="center" gap={4} as="span" noDisplayWhenEmpty>
      {!!statusCredits && <> + <FormatLoyaltyStatusCredits statusCredits={statusCredits} /></> }
      {!!trailingCaption && <Caption variant="medium" colour="neutral-three" weight="normal" as="span">
        {trailingCaption}
      </Caption>}
      {onInfoIconClick && <ClickableIcon onClick={handleClick}>
        <InlineIcon Icon={LineInfoCircleIcon} colour="neutral-one" />
      </ClickableIcon>}
    </Group>
  </Group>
}

export default _PriceRowLoyaltyPointsContent
